export default __webpack_public_path__ + "81deffd86f39e0b62dee57f8857b1362.png";